import React from 'react';
import PropTypes from 'prop-types';

export const OpenToggle = ({ active, color = "#000000", activeColor = "#000000" }) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    className={`openToggle ${active ? 'active' : ''}`}
    style={{
      stroke: active ? activeColor : color
    }}
  >
    <line
      className="plus-sign"
      y2="36"
      transform="translate(36 17.922) rotate(90)"
    />
    <line className="plus-sign" y2="14" transform="translate(18.521 22)" />
    <line className="plus-sign" y2="14" transform="translate(18.521)" />
  </svg>
);

OpenToggle.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  activeColor: PropTypes.string,
};

OpenToggle.defaultProps = {
  active: false,
  color: '#000000',
  activeColor: '#000000'
};
